exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Card {\r\n\tbackground-color: white;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Card/Card.css
// module id = 680
// module chunks = 0